import { ChatItemReadController } from './chatReadInterface';
import { AiOutlineFileSearch, AiOutlineSearch } from 'react-icons/ai';

export function createChatItemReadController(): ChatItemReadController {
    return {
        useProps(context, item, props) {
            switch (item.tool.toolName) {
                case 'read_document': {
                    const result = item.result as import('@varos/assistant-sdk').ReadDocumentToolInvocationOutput | null;
                    return {
                        Icon: AiOutlineFileSearch,
                        label: result && result.document.title
                            ? `Read "${result.document.title}"`
                            : 'Reading document',
                    };
                }
                case 'read_form': {
                    const result = item.result as import('@varos/assistant-sdk').ReadFormToolInvocationOutput | null;
                    return {
                        Icon: AiOutlineFileSearch,
                        label: result
                            ? `Read "${result.form.title}"`
                            : 'Reading form',
                    };
                }
                case 'read_collection': {
                    const result = item.result as import('@varos/assistant-sdk').ReadCollectionToolInvocationOutput | null;
                    return {
                        Icon: AiOutlineFileSearch,
                        label: result
                            ? `Read "${result.display_name}"`
                            : 'Reading collection',
                    };
                }
                case 'read_block': {
                    const result = item.result as import('@varos/assistant-sdk').ReadBlockToolInvocationOutput | null;
                    return {
                        Icon: AiOutlineFileSearch,
                        label: result
                            ? `Read block "${result.key}"`
                            : 'Reading block',
                    };
                }
                case 'read_snippet': {
                    const result = item.result as import('@varos/assistant-sdk').ReadSnippetToolInvocationOutput | null;
                    return {
                        Icon: AiOutlineFileSearch,
                        label: result
                            ? `Read snippet "${result.snippet.id}"`
                            : 'Reading snippet',
                    };
                }
                case 'list_collection_documents': {
                    const result = item.result as import('@varos/assistant-sdk').ListCollectionDocumentsToolInvocationOutput | null;
                    return {
                        Icon: AiOutlineFileSearch,
                        label: result
                            ? `List ${result.total} documents`
                            : 'Listing collection documents',
                    };
                }
                default:
                    return {
                        Icon: AiOutlineFileSearch,
                        label: 'Reading objects',
                    };
            }
        },
    };
}
